<template>
  <main>
    <div class="modal fade" id="modalRdasConsulta" tabindex="-1" role="dialog" aria-labelledby="modalRdasLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary ">
            <h5 class="modal-title text-white" id="modalRdasLabel">
              <i class="fas fa-network-wired mr-2"></i> Consulta de RDAs (Ministerio de Salud - IHCE)
            </h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body bg-light">
            <!-- Patient Mini Card -->
            <div class="card mb-3 border-0 shadow-sm">
              <div class="card-body py-3">
                <div class="row align-items-center">
                  <div class="col-md-8">
                    <span class="text-xs text-gray-500 font-weight-700 uppercase">Paciente</span>
                    <h5 class="mb-0 font-weight-700 text-gray-800">
                      {{ usuario.nombre_1 }} {{ usuario.nombre_2 }} {{ usuario.apellido_1 }} {{ usuario.apellido_2 }}
                    </h5>
                    <span class="small text-muted" v-if="usuario.tipo_documento">
                      {{ usuario.tipo_documento.codigo }} - {{ usuario.documento }}
                    </span>
                  </div>
                  <div class="col-md-4 text-md-right mt-2 mt-md-0">
                    <button class="btn btn-outline-primary btn-sm rounded-pill px-3" @click="recargarLista">
                      <i class="fas fa-sync-alt mr-1"></i> Recargar lista
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Tabs: Encuentros Clínicos vs RDA Paciente -->
            <ul class="nav nav-pills nav-fill mb-3 bg-white p-1 rounded border shadow-sm" id="rdaMainTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <a 
                  class="nav-link font-weight-700 py-2 cursor-pointer" 
                  :class="{ active: tabActivo === 'encuentros' }" 
                  @click.prevent="cambiarTab('encuentros')"
                  href="javascript:void(0)"
                >
                  <i class="fas fa-file-medical-alt mr-2"></i> Encuentros Clínicos
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a 
                  class="nav-link font-weight-700 py-2 cursor-pointer" 
                  :class="{ active: tabActivo === 'rda_paciente' }" 
                  @click.prevent="cambiarTab('rda_paciente')"
                  href="javascript:void(0)"
                >
                  <i class="fas fa-user-shield mr-2"></i> RDA Paciente
                </a>
              </li>
            </ul>

            <div class="row">
              <!-- Left Column: List of Compositions -->
              <div class="col-lg-4 col-md-5 mb-3">
                <div class="card border-0 shadow-sm h-100">
                  <div class="card-header bg-white border-bottom-0 py-3">
                    <h6 class="m-0 font-weight-700 text-gray-700" v-if="tabActivo === 'encuentros'">Composiciones / Encuentros</h6>
                    <h6 class="m-0 font-weight-700 text-gray-700" v-else>RDAs Paciente</h6>
                  </div>
                  <div class="card-body p-0" style="max-height: 500px; overflow-y: auto;">
                    
                    <!-- TAB 1: Encuentros Clínicos -->
                    <template v-if="tabActivo === 'encuentros'">
                      <!-- Loading state -->
                      <div v-if="cargandoLista" class="text-center py-5">
                        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                        <p class="small text-muted mt-2">Consultando al Ministerio de Salud...</p>
                      </div>

                      <!-- Empty state -->
                      <div v-else-if="!compositions || compositions.length === 0" class="text-center py-5 px-3">
                        <i class="fas fa-folder-open text-gray-300 fa-3x mb-2"></i>
                        <p class="small text-muted">No se encontraron encuentros clínicos (RDAs) registrados para este paciente en el Ministerio de Salud.</p>
                      </div>

                      <!-- List of items -->
                      <div v-else class="list-group list-group-flush">
                        <button 
                          v-for="item in compositions" 
                          :key="item.id" 
                          @click="seleccionarEncuentro(item.id)"
                          class="list-group-item list-group-item-action border-left-lg text-left py-3 px-3"
                          :class="compositionSeleccionada === item.id ? 'border-left-primary bg-light font-weight-700 text-primary' : 'border-left-light'"
                        >
                          <div class="d-flex w-100 justify-content-between align-items-center">
                            <div>
                              <i class="fas fa-file-medical-alt mr-2" :class="compositionSeleccionada === item.id ? 'text-primary' : 'text-muted'"></i>
                              <span class="small font-weight-600 text-dark">{{ item.title || 'Encuentro Clínico' }}</span>
                            </div>
                            <span class="text-xs text-muted font-weight-600">
                              {{ formatEncounterDateShort(item.date) }}
                            </span>
                          </div>
                        </button>
                      </div>
                    </template>

                    <!-- TAB 2: RDA Paciente -->
                    <template v-else-if="tabActivo === 'rda_paciente'">
                      <!-- Loading state -->
                      <div v-if="cargandoListaRda" class="text-center py-5">
                        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                        <p class="small text-muted mt-2">Consultando RDA Paciente al Ministerio...</p>
                      </div>

                      <!-- Empty state -->
                      <div v-else-if="!compositionsRda || compositionsRda.length === 0" class="text-center py-5 px-3">
                        <i class="fas fa-folder-open text-gray-300 fa-3x mb-2"></i>
                        <p class="small text-muted">No se encontraron RDAs de paciente registrados para este paciente en el Ministerio de Salud.</p>
                      </div>

                      <!-- List of items -->
                      <div v-else class="list-group list-group-flush">
                        <button 
                          v-for="item in compositionsRda" 
                          :key="item.id" 
                          @click="seleccionarEncuentro(item.id)"
                          class="list-group-item list-group-item-action border-left-lg text-left py-3 px-3"
                          :class="compositionSeleccionada === item.id ? 'border-left-primary bg-light font-weight-700 text-primary' : 'border-left-light'"
                        >
                          <div class="d-flex w-100 justify-content-between align-items-center">
                            <div>
                              <i class="fas fa-user-shield mr-2" :class="compositionSeleccionada === item.id ? 'text-primary' : 'text-muted'"></i>
                              <span class="small font-weight-600 text-dark">{{ item.title || 'RDA Antecedentes Paciente' }}</span>
                            </div>
                            <span class="text-xs text-muted font-weight-600">
                              {{ formatEncounterDateShort(item.date) }}
                            </span>
                          </div>
                          <span class="badge badge-light border d-block mt-1 text-truncate text-muted text-xs text-left" v-if="item.region && item.region !== 'N/A'">
                            <i class="fas fa-building mr-1"></i>{{ item.region }}
                          </span>
                        </button>
                      </div>
                    </template>

                  </div>
                </div>
              </div>

              <!-- Right Column: Detail of Selected Composition -->
              <div class="col-lg-8 col-md-7 mb-3">
                <div class="card border-0 shadow-sm h-100">
                  <div class="card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
                    <h6 class="m-0 font-weight-700 text-gray-700">Detalles del Encuentro Clínico</h6>
                    <span v-if="compositionSeleccionada" class="badge badge-primary-soft text-primary font-weight-600">
                      ID: {{ compositionSeleccionada }}
                    </span>
                  </div>

                  <div class="card-body">
                    <!-- Default State: No selected item -->
                    <div v-if="!compositionSeleccionada" class="text-center py-5 my-5 text-gray-400">
                      <i class="fas fa-info-circle fa-3x mb-2"></i>
                      <p>Selecciona un encuentro de la lista de la izquierda para ver su información detallada.</p>
                    </div>

                    <!-- Loading detail state -->
                    <div v-else-if="cargandoDetalle" class="text-center py-5 my-5">
                      <div class="spinner-border text-primary" role="status"></div>
                      <p class="small text-muted mt-2">Obteniendo documento completo del Ministerio...</p>
                    </div>

                    <!-- Detail Display -->
                    <div v-else-if="detalleEncuentro" class="detail-container">
                      
                      <!-- Tabs Navigation -->
                      <ul class="nav nav-tabs border-bottom-0 mb-3 bg-light p-1 rounded" id="detailTab" role="tablist" style="gap: 5px;">
                        <li class="nav-item" role="presentation">
                          <button class="nav-link btn btn-sm border-0 font-weight-700 active px-3" id="resumen-tab" data-toggle="tab" data-target="#resumen" type="button" role="tab" aria-controls="resumen" aria-selected="true">
                            <i class="fas fa-file-invoice mr-1"></i> Resumen
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link btn btn-sm border-0 font-weight-700 px-3" id="diagnosticos-tab" data-toggle="tab" data-target="#diagnosticos" type="button" role="tab" aria-controls="diagnosticos" aria-selected="false">
                            <i class="fas fa-notes-medical mr-1"></i> Clínico
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link btn btn-sm border-0 font-weight-700 px-3" id="json-tab" data-toggle="tab" data-target="#json" type="button" role="tab" aria-controls="json" aria-selected="false">
                            <i class="fas fa-code mr-1"></i> FHIR Bundle JSON
                          </button>
                        </li>
                      </ul>

                      <!-- Tab Content -->
                      <div class="tab-content" id="detailTabContent">
                        
                        <!-- TAB: Resumen -->
                        <div class="tab-pane fade show active" id="resumen" role="tabpanel" aria-labelledby="resumen-tab">
                                             <!-- Top Card: RDA / Atención -->
                          <div class="card shadow-none border border-light-200 mb-3">
                            <div class="card-body p-3">
                              <div class="d-flex justify-content-between align-items-start border-bottom pb-2 mb-2">
                                <div>
                                  <span class="text-xs text-gray-500 font-weight-700 uppercase d-block">Documento / Atención</span>
                                  <h6 class="m-0 font-weight-700 text-gray-800">
                                    {{ getCompositionInfo().title || 'Consulta Externa' }}
                                  </h6>
                                  <span v-if="getCompositionInfo().serviceTypeDisplay" class="text-xs text-gray-600">
                                    Servicio: {{ getCompositionInfo().serviceTypeDisplay }} <span v-if="getCompositionInfo().serviceTypeCode">({{ getCompositionInfo().serviceTypeCode }})</span>
                                  </span>
                                </div>
                                <span class="badge badge-success-soft text-success px-2 py-1 font-weight-600 uppercase text-xs">
                                  <i class="fas fa-check-circle mr-1"></i> {{ getCompositionInfo().status || 'finalized' }}
                                </span>
                              </div>
                              <div class="row text-sm">
                                <div class="col-md-4 col-6">
                                  <span class="text-xs text-gray-500 d-block">Fecha Envío (Ministerio)</span>
                                  <span class="font-weight-600 text-gray-800">{{ getCompositionInfo().date || 'N/A' }}</span>
                                </div>
                                <div class="col-md-4 col-6">
                                  <span class="text-xs text-gray-500 d-block">Fecha Registro Clínico</span>
                                  <span class="font-weight-600 text-gray-800">{{ getCompositionInfo().encounterDate || 'N/A' }}</span>
                                </div>
                                <div v-if="tabActivo === 'encuentros'" class="col-md-4 col-12 mt-2 mt-md-0">
                                  <span class="text-xs text-gray-500 d-block">No. Registro Interno</span>
                                  <span class="font-weight-600 text-gray-800">{{ getCompositionInfo().encounterInternalId || 'N/A' }}</span>
                                </div>
                              </div>
                              <div v-if="compositionSeleccionada && tabActivo === 'encuentros'" class="mt-3 pt-2 border-top d-flex justify-content-between align-items-center flex-wrap">
                                <div>
                                  <span class="text-xs text-gray-500 font-weight-700 d-block uppercase">Documento Clínico / Epicrisis</span>
                                  <small class="text-gray-600">Consulta o descarga la representación gráfica oficial en PDF</small>
                                </div>
                                <button 
                                  class="btn btn-sm btn-outline-danger font-weight-600 py-1 px-3 mt-2 mt-sm-0"
                                  :disabled="descargandoPDF"
                                  @click="abrirDocumentoPDF"
                                >
                                  <i v-if="descargandoPDF" class="fas fa-spinner fa-spin mr-1"></i>
                                  <i v-else class="fas fa-file-pdf text-danger mr-1"></i>
                                  {{ descargandoPDF ? 'Cargando PDF...' : 'Ver PDF Epicrisis' }}
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Información del Paciente -->
                          <div v-if="getPatientInfo()" class="card shadow-none border border-light-200 mb-3">
                            <div class="card-body p-3">
                              <h6 class="font-weight-700 text-primary small mb-3 uppercase">
                                <i class="fas fa-user mr-1 text-primary"></i> DATOS DEL PACIENTE
                              </h6>
                              <div class="row text-sm">
                                <div class="col-md-4 mb-2">
                                  <span class="text-gray-500 text-xs d-block">Nombre Completo</span>
                                  <strong class="text-gray-800">{{ getPatientInfo().fullName }}</strong>
                                </div>
                                <div class="col-md-4 mb-2">
                                  <span class="text-gray-500 text-xs d-block">Documento</span>
                                  <span class="text-gray-800 font-weight-600">{{ getPatientInfo().docType }} {{ getPatientInfo().docNumber }}</span>
                                </div>
                                <div class="col-md-4 mb-2">
                                  <span class="text-gray-500 text-xs d-block">Fecha / Hora Nacimiento</span>
                                  <span class="text-gray-800 font-weight-600">
                                    {{ getPatientInfo().birthDate }}
                                    <small v-if="getPatientInfo().birthTime" class="text-gray-500">({{ getPatientInfo().birthTime }})</small>
                                  </span>
                                </div>
                                <div class="col-md-3 mb-2">
                                  <span class="text-gray-500 text-xs d-block">Sexo Biológico</span>
                                  <span class="text-gray-800 text-capitalize">{{ getPatientInfo().biologicalGender }}</span>
                                </div>
                                <div class="col-md-3 mb-2">
                                  <span class="text-gray-500 text-xs d-block">Identidad de Género</span>
                                  <span class="text-gray-800">{{ getPatientInfo().genderIdentity }}</span>
                                </div>
                                <div class="col-md-3 mb-2">
                                  <span class="text-gray-500 text-xs d-block">Nacionalidad</span>
                                  <span class="text-gray-800">{{ getPatientInfo().nationality }}</span>
                                </div>
                                <div class="col-md-3 mb-2">
                                  <span class="text-gray-500 text-xs d-block">Etnia</span>
                                  <span class="text-gray-800">{{ getPatientInfo().ethnicity }}</span>
                                </div>
                                <div class="col-md-3">
                                  <span class="text-gray-500 text-xs d-block">Discapacidad</span>
                                  <span class="text-gray-800">{{ getPatientInfo().disability }}</span>
                                </div>
                                <div class="col-md-3">
                                  <span class="text-gray-500 text-xs d-block">Zona Residencia</span>
                                  <span class="text-gray-800">{{ getPatientInfo().residenceZone }}</span>
                                </div>
                                <div class="col-md-6">
                                  <span class="text-gray-500 text-xs d-block">Ubicación</span>
                                  <span class="text-gray-800">{{ getPatientInfo().city }} ({{ getPatientInfo().country }})</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- EPS (Solo para Encuentros Clínicos) -->
                          <div v-if="tabActivo === 'encuentros'" class="card shadow-none border border-light-200 mb-3">
                            <div class="card-body p-3">
                              <h6 class="font-weight-700 text-primary small mb-2 uppercase">
                                <i class="fas fa-shield-alt mr-1 text-primary"></i> ENTIDAD ADMINISTRADORA (EPS / EAPB)
                              </h6>
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <span class="text-gray-800 font-weight-600">{{ getPatientInfo() ? getPatientInfo().epsName : 'N/A' }}</span>
                                </div>
                                <span class="badge badge-primary-soft text-primary font-weight-600">
                                  Código: {{ (getPatientInfo() && getPatientInfo().epsCode !== 'N/A') ? getPatientInfo().epsCode : 'Sin Código' }}
                                </span>
                              </div>
                            </div>
                          </div>

                          <!-- Profesional & IPS -->
                          <div class="row">
                            <div class="col-md-6 mb-3 mb-md-0">
                              <div class="card shadow-none border border-light-200 h-100">
                                <div class="card-body p-3">
                                  <h6 class="font-weight-700 text-primary small mb-2 uppercase">
                                    <i class="fas fa-user-md mr-1 text-primary"></i> PROFESIONAL DE SALUD
                                  </h6>
                                  <div class="text-sm">
                                    <strong class="text-gray-800 d-block">{{ getCompositionInfo().author || 'N/A' }}</strong>
                                    <small class="text-gray-600 d-block" v-if="getCompositionInfo().authorDocument">Doc: {{ getCompositionInfo().authorDocument }}</small>
                                    <small class="text-gray-600 d-block" v-if="getCompositionInfo().authorRethus">{{ getCompositionInfo().authorRethus }}</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="card shadow-none border border-light-200 h-100">
                                <div class="card-body p-3">
                                  <h6 class="font-weight-700 text-primary small mb-2 uppercase">
                                    <i class="fas fa-hospital mr-1 text-primary"></i> INSTITUCIÓN PRESTADORA (IPS)
                                  </h6>
                                  <div class="text-sm">
                                    <strong class="text-gray-800 d-block">{{ getCompositionInfo().organization || 'N/A' }}</strong>
                                    <small class="text-gray-600 d-block" v-if="getCompositionInfo().orgNit">NIT: {{ getCompositionInfo().orgNit }}</small>
                                    <small class="text-gray-600 d-block" v-if="getCompositionInfo().orgReps">REPS: {{ getCompositionInfo().orgReps }}</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>

                        <!-- TAB: Clínico (Diagnósticos, Alergias, Medicamentos, Antecedentes Familiares, Procedimientos, Incapacidades) -->
                        <div class="tab-pane fade" id="diagnosticos" role="tabpanel" aria-labelledby="diagnosticos-tab">
                          
                          <!-- Diagnósticos -->
                          <div class="mb-4">
                            <h6 class="font-weight-700 text-primary small border-bottom pb-2 mb-3 uppercase">
                              <i class="fas fa-stethoscope mr-1 text-primary"></i> DIAGNÓSTICOS / PROBLEMAS DE SALUD
                            </h6>
                            <div v-if="getClinicalInfo().diagnoses.length === 0" class="text-muted small italic">
                              No hay diagnósticos registrados.
                            </div>
                            <div v-else class="list-group list-group-flush border-0">
                              <div v-for="(diag, idx) in getClinicalInfo().diagnoses" :key="idx" class="py-2 border-bottom">
                                <div class="d-flex justify-content-between align-items-start">
                                  <div>
                                    <span class="badge badge-primary-soft text-primary font-weight-700 mr-2">{{ diag.code }}</span>
                                    <span class="text-gray-800 font-weight-600">{{ diag.display }}</span>
                                  </div>
                                  <span v-if="diag.isPrimary" class="badge badge-success-soft text-success text-xs font-weight-600">Principal</span>
                                </div>
                                <div class="text-xs text-gray-700 mt-1">
                                  <span v-if="diag.category" class="mr-3">Categoría: {{ diag.category }}</span>
                                  <span v-if="diag.verificationStatus">Verificación: {{ diag.verificationStatus }}</span>
                                  <span v-if="diag.clinicalStatus" class="ml-3">Estado: {{ diag.clinicalStatus }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Alergias e Intolerancias -->
                          <div class="mb-4">
                            <h6 class="font-weight-700 text-primary small border-bottom pb-2 mb-3 uppercase">
                              <i class="fas fa-allergies mr-1 text-primary"></i> ALERGIAS E INTOLERANCIAS
                            </h6>
                            <div v-if="getClinicalInfo().allergies.length === 0" class="text-muted small italic">
                              No se reportan alergias e intolerancias.
                            </div>
                            <div v-else class="list-group list-group-flush border-0">
                              <div v-for="(alg, idx) in getClinicalInfo().allergies" :key="idx" class="py-2 border-bottom">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div>
                                    <span class="badge badge-info-soft mr-2">{{ alg.type }}</span>
                                    <strong class="text-gray-800">{{ alg.display }}</strong>
                                  </div>
                                  <span class="text-xs text-gray-700">{{ alg.clinicalStatus }}</span>
                                </div>
                                <div class="text-xs text-gray-700 mt-1">
                                  <span class="mr-3">Verificación: <span class="text-success">{{ alg.verificationStatus }}</span></span>
                                  <span>Fecha: {{ alg.recordedDate }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Medicamentos -->
                          <div class="mb-4">
                            <h6 class="font-weight-700 text-primary small border-bottom pb-2 mb-3 uppercase">
                              <i class="fas fa-pills mr-1 text-primary"></i> MEDICAMENTOS (RECETADOS / MANIFESTADOS)
                            </h6>
                            <div v-if="getClinicalInfo().medications.length === 0" class="text-muted small italic">
                              No se reportan medicamentos.
                            </div>
                            <div v-else class="table-responsive">
                              <table class="table table-sm table-hover border-0">
                                <thead class="bg-light text-xs">
                                  <tr>
                                    <th class="border-0 font-weight-600">Código</th>
                                    <th class="border-0 font-weight-600">Principio Activo</th>
                                    <th class="border-0 font-weight-600">Descripción Comercial</th>
                                    <th class="border-0 font-weight-600">Dosis / Vía</th>
                                    <th class="border-0 font-weight-600">Frecuencia</th>
                                    <th class="border-0 font-weight-600">Estado</th>
                                  </tr>
                                </thead>
                                <tbody class="text-sm">
                                  <tr v-for="(med, idx) in getClinicalInfo().medications" :key="idx" class="border-bottom">
                                    <td class="align-middle py-2">
                                      <span v-if="med.code" class="text-primary text-xs font-weight-700">{{ med.code }}</span>
                                      <span v-else class="text-gray-500">-</span>
                                    </td>
                                    <td class="align-middle py-2 font-weight-600 text-gray-800">
                                      {{ med.activeIngredient || 'N/A' }}
                                    </td>
                                    <td class="align-middle py-2 text-gray-600">
                                      {{ med.display }}
                                    </td>
                                    <td class="align-middle py-2 text-gray-600">
                                      {{ (med.doseValue || med.doseUnit) ? (med.doseValue + ' ' + med.doseUnit) : '-' }}
                                      <small v-if="med.route" class="d-block text-gray-500">({{ med.route }})</small>
                                    </td>
                                    <td class="align-middle py-2 text-gray-600">
                                      {{ (med.rateValue || med.rateUnit) ? ('Cada ' + med.rateValue + ' ' + med.rateUnit) : '-' }}
                                    </td>
                                    <td class="align-middle py-2">
                                      <span class="text-xs text-gray-500">{{ med.status }}</span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <!-- Antecedentes Familiares (Solo para RDA Paciente) -->
                          <div v-if="tabActivo === 'rda_paciente'" class="mb-4">
                            <h6 class="font-weight-700 text-primary small border-bottom pb-2 mb-3 uppercase">
                              <i class="fas fa-users mr-1 text-primary"></i> ANTECEDENTES FAMILIARES
                            </h6>
                            <div v-if="getClinicalInfo().familyHistory.length === 0" class="text-muted small italic">
                              No se reportan antecedentes familiares.
                            </div>
                            <div v-else class="list-group list-group-flush border-0">
                              <div v-for="(fam, idx) in getClinicalInfo().familyHistory" :key="idx" class="py-2 border-bottom">
                                <div class="d-flex align-items-center mb-1">
                                  <span class="badge badge-info-soft mr-2">{{ fam.relationshipDisplay }}</span>
                                  <span class="text-xs text-gray-700">Estado: {{ fam.status }}</span>
                                </div>
                                <div v-for="(cond, cIdx) in fam.conditions" :key="cIdx" class="ml-3 text-sm">
                                  <i class="fas fa-angle-right text-primary mr-1"></i>
                                  <span class="font-weight-600 text-gray-800" v-if="cond.code">[{{ cond.code }}] </span>
                                  <span class="text-gray-800">{{ cond.display }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Procedimientos y Solicitudes (Solo para Encuentros Clínicos) -->
                          <div v-if="tabActivo === 'encuentros'" class="mb-4">
                            <h6 class="font-weight-700 text-primary small border-bottom pb-2 mb-3 uppercase">
                              <i class="fas fa-clipboard-list mr-1 text-primary"></i> PROCEDIMIENTOS Y ÓRDENES
                            </h6>
                            <div v-if="getClinicalInfo().procedures.length === 0" class="text-muted small italic">
                              No se ordenaron procedimientos.
                            </div>
                            <div v-else class="list-group list-group-flush border-0">
                              <div v-for="(proc, idx) in getClinicalInfo().procedures" :key="idx" class="py-2 border-bottom d-flex align-items-center">
                                <span class="badge badge-primary-soft text-primary font-weight-700 mr-2">{{ proc.code }}</span>
                                <span class="text-gray-800 font-weight-600">{{ proc.display }}</span>
                              </div>
                            </div>
                          </div>

                          <!-- Incapacidades (Solo para Encuentros Clínicos) -->
                          <div v-if="tabActivo === 'encuentros'" class="mb-4">
                            <h6 class="font-weight-700 text-primary small border-bottom pb-2 mb-3 uppercase">
                              <i class="fas fa-user-md mr-1 text-primary"></i> INCAPACIDADES / LICENCIAS
                            </h6>
                            <div v-if="getClinicalInfo().sickLeave.length === 0" class="text-muted small italic">
                              No se reportaron incapacidades.
                            </div>
                            <div v-else class="list-group list-group-flush border-0">
                              <div v-for="(sick, idx) in getClinicalInfo().sickLeave" :key="idx" class="py-2 border-bottom d-flex justify-content-between align-items-center">
                                <div>
                                  <strong class="text-gray-800">Días: {{ sick.days }}</strong>
                                  <div class="text-gray-500 text-xs">Inicio: {{ sick.startDate }}</div>
                                </div>
                                <span class="text-xs text-gray-500">{{ sick.reason }}</span>
                              </div>
                            </div>
                          </div>

                          <!-- Ocupación del Paciente (Solo para Encuentros Clínicos / RDA Consulta) -->
                          <div v-if="tabActivo === 'encuentros'" class="mb-4">
                            <h6 class="font-weight-700 text-primary small border-bottom pb-2 mb-3 uppercase">
                              <i class="fas fa-briefcase mr-1 text-primary"></i> OCUPACIÓN DEL PACIENTE
                            </h6>
                            <div v-if="!getClinicalInfo().occupation" class="text-muted small italic">
                              No se registró información de ocupación.
                            </div>
                            <div v-else class="list-group list-group-flush border-0">
                              <div class="py-2 border-bottom d-flex align-items-center">
                                <span class="badge badge-light border text-gray-700 font-weight-700 mr-2">Código: {{ getClinicalInfo().occupation.code }}</span>
                                <span class="text-gray-800 font-weight-600">{{ getClinicalInfo().occupation.display }}</span>
                              </div>
                            </div>
                          </div>

                          <!-- Factores de Riesgo (Solo para Encuentros Clínicos / RDA Consulta) -->
                          <div v-if="tabActivo === 'encuentros'" class="mb-4">
                            <h6 class="font-weight-700 text-primary small border-bottom pb-2 mb-3 uppercase">
                              <i class="fas fa-exclamation-triangle mr-1 text-primary"></i> FACTORES DE RIESGO
                            </h6>
                            <div v-if="getClinicalInfo().riskFactors.length === 0" class="text-muted small italic">
                              No se registraron factores de riesgo.
                            </div>
                            <div v-else class="list-group list-group-flush border-0">
                              <div v-for="(rf, idx) in getClinicalInfo().riskFactors" :key="idx" class="py-2 border-bottom">
                                <div class="d-flex justify-content-between align-items-center mb-1">
                                  <strong class="text-gray-800 text-sm">#{{ idx + 1 }} {{ rf.display }}</strong>
                                  <span class="text-xs text-gray-700">📝 {{ rf.status === 'registered' ? 'Registrado' : rf.status }}</span>
                                </div>
                                <div class="text-xs text-gray-700">
                                  Código (FactorRiesgo): <strong>{{ rf.code }}</strong>
                                </div>
                                <div v-if="rf.description" class="text-xs text-gray-700 mt-1">
                                  Descripción: {{ rf.description }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- TAB: FHIR Bundle JSON -->
                        <div class="tab-pane fade" id="json" role="tabpanel" aria-labelledby="json-tab">
                          <!-- Documentos adjuntos -->
                          <div v-if="getClinicalInfo().documents.length > 0" class="mb-3">
                            <h6 class="font-weight-700 text-primary border-bottom pb-2">
                              <i class="fas fa-file-pdf mr-1"></i> Documentos Adjuntos (Ministerio)
                            </h6>
                            <div class="list-group">
                              <a
                                v-for="(doc, idx) in getClinicalInfo().documents"
                                :key="idx"
                                href="javascript:void(0)"
                                @click="abrirDocumentoPDF"
                                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-2"
                              >
                                <div>
                                  <i class="fas fa-file-pdf text-danger mr-2"></i>
                                  <span class="font-weight-600">{{ doc.title || 'Documento Clínico' }}</span>
                                  <span class="badge badge-light ml-2">{{ doc.format || 'PDF' }}</span>
                                </div>
                                <span class="badge badge-primary-soft text-primary">
                                  <i v-if="descargandoPDF" class="fas fa-spinner fa-spin mr-1"></i>
                                  <i v-else class="fas fa-external-link-alt mr-1"></i> 
                                  {{ descargandoPDF ? 'Cargando...' : 'Abrir' }}
                                </span>
                              </a>
                            </div>
                          </div>
                          <!-- JSON crudo -->
                          <div class="position-relative">
                            <button class="btn btn-xs btn-outline-dark position-absolute" style="top: 10px; right: 10px; z-index: 10;" @click="copiarJson">
                              <i class="fas fa-copy mr-1"></i> Copiar JSON
                            </button>
                            <pre class="bg-dark text-light p-3 rounded small" style="max-height: 400px; overflow-y: auto;"><code>{{ JSON.stringify(detalleEncuentro, null, 2) }}</code></pre>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-white border-top-0">
            <button type="button" class="btn btn-light btn-sm" data-dismiss="modal">
              Cerrar <i class="fa fa-times-circle fa-fw"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ihceService from '../../../../services/ihceService';
import Toast from '../../../../components/common/utilities/toast';
import $ from 'jquery';
import dayjs from 'dayjs';

export default {
  props: {
    usuario: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tabActivo: 'encuentros',
      cargandoLista: false,
      cargandoListaRda: false,
      cargandoDetalle: false,
      descargandoPDF: false,
      compositions: [],
      compositionsRda: [],
      compositionSeleccionada: null,
      detalleEncuentro: null
    };
  },
  methods: {
    /**
     * Abre el modal y consulta los encuentros del paciente.
     */
    openModal() {
       this.$nextTick(() => {     
        $('#modalRdasConsulta').modal('show');
      });
      this.tabActivo = 'encuentros';
      this.compositions = [];
      this.compositionsRda = [];
      this.compositionSeleccionada = null;
      this.detalleEncuentro = null;
      this.obtenerEncuentros();
    },

    /**
     * Cambia de pestaña activa entre Encuentros Clínicos y RDA Paciente.
     */
    cambiarTab(tab) {
      if (this.tabActivo === tab) return;
      this.tabActivo = tab;
      this.compositionSeleccionada = null;
      this.detalleEncuentro = null;
      if (tab === 'encuentros') {
        if (this.compositions.length === 0) {
          this.obtenerEncuentros();
        }
      } else if (tab === 'rda_paciente') {
        if (this.compositionsRda.length === 0) {
          this.obtenerRdaPaciente();
        }
      }
    },

    /**
     * Recarga la lista correspondiente a la pestaña activa.
     */
    recargarLista() {
      if (this.tabActivo === 'encuentros') {
        this.obtenerEncuentros();
      } else {
        this.obtenerRdaPaciente();
      }
    },

    /**
     * Obtiene los encuentros desde el endpoint en sinu-salud-project
     */
    async obtenerEncuentros() {
      try {
        if (!this.usuario.documento) {
          Toast.fire({
            icon: 'error',
            title: 'El paciente no posee número de documento'
          });
          return;
        }

        const userDocument = this.$store.state.user?.documento;
        if (!userDocument) {
          Toast.fire({
            icon: 'error',
            title: 'No se detectó documento del profesional logueado'
          });
          return;
        }

        this.cargandoLista = true;
        this.compositionSeleccionada = null;
        this.detalleEncuentro = null;

        const payload = {
          documento_paciente: String(this.usuario.documento),
          documento_usuario: String(userDocument),
          tipo_documento_paciente: this.usuario.tipo_documento ? this.usuario.tipo_documento.codigo : 'CC'
        };

        const response = await ihceService.consultarEncuentros(payload);

        if (response.data && response.data.success) {
          this.compositions = response.data.compositions || [];
          if (this.compositions.length > 0) {
            Toast.fire({
              icon: 'success',
              title: `Se encontraron ${this.compositions.length} encuentros clínicos.`
            });
          }
        } else {
          this.compositions = [];
        }
      } catch (error) {
        console.error('Error al obtener encuentros clínicos:', error);
        this.compositions = [];
        Toast.fire({
          icon: 'error',
          title: error.response?.data?.message || 'Error al consultar encuentros en el Ministerio'
        });
      } finally {
        this.cargandoLista = false;
      }
    },

    /**
     * Obtiene los RDAs de antecedentes del paciente desde el backend.
     */
    async obtenerRdaPaciente() {
      try {
        if (!this.usuario.documento) {
          Toast.fire({
            icon: 'error',
            title: 'El paciente no posee número de documento'
          });
          return;
        }

        const userDocument = this.$store.state.user?.documento;
        if (!userDocument) {
          Toast.fire({
            icon: 'error',
            title: 'No se detectó documento del profesional logueado'
          });
          return;
        }

        this.cargandoListaRda = true;
        this.compositionSeleccionada = null;
        this.detalleEncuentro = null;

        const payload = {
          documento_paciente: String(this.usuario.documento),
          documento_usuario: String(userDocument),
          tipo_documento_paciente: this.usuario.tipo_documento ? this.usuario.tipo_documento.codigo : 'CC',
          tipo_documento: this.usuario.tipo_documento ? this.usuario.tipo_documento.codigo : 'CC'
        };

        const response = await ihceService.consultarRdaPaciente(payload);

        if (response.data && response.data.success) {
          this.compositionsRda = response.data.compositions || [];
          if (this.compositionsRda.length > 0) {
            Toast.fire({
              icon: 'success',
              title: `Se encontraron ${this.compositionsRda.length} RDAs del paciente.`
            });
          }
        } else {
          this.compositionsRda = [];
        }
      } catch (error) {
        console.error('Error al obtener RDA del paciente:', error);
        this.compositionsRda = [];
        Toast.fire({
          icon: 'error',
          title: error.response?.data?.message || 'Error al consultar RDA del paciente en el Ministerio'
        });
      } finally {
        this.cargandoListaRda = false;
      }
    },

    /**
     * Selecciona una composición y descarga sus detalles.
     */
    async seleccionarEncuentro(idComp) {
      try {
        this.compositionSeleccionada = idComp;
        this.cargandoDetalle = true;
        this.detalleEncuentro = null;

        const response = await ihceService.consultarDocumento(idComp);
        this.detalleEncuentro = response.data;
      } catch (error) {
        console.error('Error al obtener el detalle del encuentro:', error);
        Toast.fire({
          icon: 'error',
          title: 'Error al consultar el documento del encuentro clínico'
        });
      } finally {
        this.cargandoDetalle = false;
      }
    },

    /**
     * Extrae información básica del recurso Patient del Bundle de respuesta.
     */
    getPatientInfo() {
      if (!this.detalleEncuentro || !this.detalleEncuentro.entry) {
        return null;
      }

      const patientEntry = this.detalleEncuentro.entry.find(
        e => e.resource && e.resource.resourceType === 'Patient'
      );

      if (!patientEntry) {
        return null;
      }

      const p = patientEntry.resource;

      // Full Name
      let fullName = '';
      if (p.name && p.name[0]) {
        const given = p.name[0].given ? p.name[0].given.join(' ') : '';
        const family = p.name[0].family || '';
        fullName = `${given} ${family}`.trim();
      }

      // Document Type & Number
      let docType = 'N/A';
      let docNumber = 'N/A';
      if (p.identifier && p.identifier[0]) {
        docNumber = p.identifier[0].value || 'N/A';
        const typeCoding = p.identifier[0].type?.coding?.find(
          c => c.system?.includes('ColombianPersonIdentifier')
        );
        docType = typeCoding?.code || p.identifier[0].type?.coding?.[0]?.code || 'CC';
      }

      // Birth Date & Time
      let birthDate = p.birthDate || 'N/A';
      let birthTime = '';
      const birthTimeExt = p._birthDate?.extension?.find(
        ext => ext.url?.includes('ExtensionBirthTime')
      );
      if (birthTimeExt && birthTimeExt.valueTime) {
        birthTime = birthTimeExt.valueTime;
      }

      // Gender (Biological)
      let biologicalGender = p.gender || 'N/A';
      const genderExt = p._gender?.extension?.find(
        ext => ext.url?.includes('ExtensionBiologicalGender')
      );
      if (genderExt && genderExt.valueCoding) {
        biologicalGender = genderExt.valueCoding.display || biologicalGender;
      }

      // Gender Identity
      let genderIdentity = 'N/A';
      const genderIdExt = p.extension?.find(ext => ext.url?.includes('ExtensionPatientGenderIdentity'));
      if (genderIdExt && genderIdExt.valueCoding) {
        genderIdentity = genderIdExt.valueCoding.display || 'N/A';
      }

      // Nationality
      let nationality = 'N/A';
      const natExt = p.extension?.find(ext => ext.url?.includes('ExtensionPatientNationality'));
      if (natExt && natExt.valueCoding) {
        nationality = natExt.valueCoding.display || 'N/A';
      }

      // Ethnicity
      let ethnicity = 'N/A';
      const ethExt = p.extension?.find(ext => ext.url?.includes('ExtensionPatientEthnicity'));
      if (ethExt && ethExt.valueCoding) {
        ethnicity = ethExt.valueCoding.display || 'N/A';
      }

      // Disability
      let disability = 'N/A';
      const disExt = p.extension?.find(ext => ext.url?.includes('ExtensionPatientDisability'));
      if (disExt && disExt.valueCoding) {
        disability = disExt.valueCoding.display || 'N/A';
      }

      // Residence Zone & City/Country
      let residenceZone = 'N/A';
      let city = 'N/A';
      let country = 'N/A';

      if (p.address && p.address[0]) {
        const addr = p.address[0];
        country = addr.country || 'Colombia';
        
        const zoneExt = addr.extension?.find(ext => ext.url?.includes('ExtensionResidenceZone'));
        if (zoneExt && zoneExt.valueCoding) {
          residenceZone = zoneExt.valueCoding.display || 'N/A';
        }

        city = addr.city || 'N/A';
      }

      // EPS / EAPB Organization resolver (con fallback al paciente)
      let epsName = 'N/A';
      let epsCode = 'N/A';
      const eapbEntry = this.detalleEncuentro.entry.find(
        e => e.resource && 
             e.resource.resourceType === 'Organization' &&
             (
               e.resource.meta?.profile?.some(p => p.includes('HealthBenefitPlanAdminOrganizationRDA')) ||
               e.resource.identifier?.some(i => i.type?.coding?.some(c => c.code === 'EAPB'))
             )
      );

      if (eapbEntry && eapbEntry.resource) {
        epsName = eapbEntry.resource.name || 'N/A';
        const eapbId = eapbEntry.resource.identifier?.find(
          i => i.type?.coding?.some(c => c.code === 'EAPB') || i.system?.includes('EAPB')
        );
        epsCode = eapbId ? eapbId.value : 'N/A';
      } else if (this.usuario) {
        if (this.usuario.eps) {
          epsName = this.usuario.eps.nombre || this.usuario.eps.razon_social || epsName;
          epsCode = this.usuario.eps.codigo || epsCode;
        } else if (this.usuario.eapb) {
          epsName = this.usuario.eapb.nombre || epsName;
          epsCode = this.usuario.eapb.codigo || epsCode;
        }
      }

      return {
        fullName: fullName || 'Paciente no identificado',
        docType,
        docNumber,
        birthDate,
        birthTime,
        biologicalGender,
        genderIdentity,
        nationality,
        ethnicity,
        disability,
        residenceZone,
        city,
        country,
        epsName,
        epsCode
      };
    },

    /**
     * Extrae información básica del recurso Composition del Bundle de respuesta.
     */
    getCompositionInfo() {
      if (!this.detalleEncuentro || !this.detalleEncuentro.entry) {
        return {};
      }

      // Buscar el recurso Composition
      const compositionEntry = this.detalleEncuentro.entry.find(
        e => e.resource && e.resource.resourceType === 'Composition'
      );

      // Buscar el recurso Encounter
      const encounterEntry = this.detalleEncuentro.entry.find(
        e => e.resource && e.resource.resourceType === 'Encounter'
      );

      // Buscar el recurso Organization
      const organizationEntry = this.detalleEncuentro.entry.find(
        e => e.resource && e.resource.resourceType === 'Organization' &&
             !e.resource.meta?.profile?.some(p => p.includes('HealthBenefitPlanAdminOrganizationRDA'))
      );

      // Buscar el recurso Practitioner
      const practitionerEntry = this.detalleEncuentro.entry.find(
        e => e.resource && e.resource.resourceType === 'Practitioner'
      );

      const comp = compositionEntry ? compositionEntry.resource : {};
      const enc = encounterEntry ? encounterEntry.resource : {};
      const org = organizationEntry ? organizationEntry.resource : {};
      const prac = practitionerEntry ? practitionerEntry.resource : {};

      let dateFormatted = comp.date;
      if (dateFormatted) {
        dateFormatted = new Date(dateFormatted).toLocaleString();
      }

      let encounterDate = '';
      if (enc.period && enc.period.start) {
        encounterDate = new Date(enc.period.start).toLocaleString();
      }

      let encounterInternalId = '';
      if (enc.identifier && Array.isArray(enc.identifier)) {
        const encIdObj = enc.identifier.find(i => i.id === 'EncounterIdentifier');
        if (encIdObj) {
          encounterInternalId = encIdObj.value || '';
        } else if (enc.identifier[0]) {
          encounterInternalId = enc.identifier[0].value || '';
        }
      }

      let authorName = '';
      if (prac.name && prac.name[0]) {
        const given = prac.name[0].given ? prac.name[0].given.join(' ') : '';
        const family = prac.name[0].family || '';
        authorName = `${given} ${family}`.trim();
      }

      let authorDocument = '';
      if (prac.identifier && prac.identifier.length > 0) {
        authorDocument = prac.identifier[0].value || '';
      }

      let authorRethus = '';
      if (prac.qualification && prac.qualification[0]) {
        const qual = prac.qualification[0];
        const qualName = qual.code?.coding?.[0]?.display || '';
        const rethusVal = qual.identifier?.[0]?.value || '';
        if (qualName || rethusVal) {
          authorRethus = `${qualName}${rethusVal ? ' (RETHUS: ' + rethusVal + ')' : ''}`;
        }
      }

      let serviceTypeDisplay = '';
      let serviceTypeCode = '';
      if (enc.serviceType && enc.serviceType.coding && enc.serviceType.coding[0]) {
        serviceTypeDisplay = enc.serviceType.coding[0].display || '';
        serviceTypeCode = enc.serviceType.coding[0].code || '';
      }

      let organizationName = org.name || 'IPS Principal';
      let orgNit = '';
      let orgReps = '';
      if (org.identifier && Array.isArray(org.identifier)) {
        const nitObj = org.identifier.find(i => i.id === 'TaxIdentifier-0' || i.type?.coding?.some(c => c.code === 'NIT'));
        if (nitObj) orgNit = nitObj.value || '';

        const repsObj = org.identifier.find(i => i.id === 'HealthcareProviderIdentifier-0' || i.type?.coding?.some(c => c.code === 'CodigoPrestador'));
        if (repsObj) orgReps = repsObj.value || '';
      }

      if (org.address && org.address[0]) {
        const addr = org.address[0];
        const city = addr.city || '';
        const state = addr.state || '';
        const addressParts = [];
        if (city) addressParts.push(city);
        if (state) addressParts.push(state);
        if (addressParts.length > 0) {
          organizationName = `${organizationName} (${addressParts.join(' - ')})`;
        }
      }

      return {
        title: comp.title || 'Consulta Externa',
        date: dateFormatted,
        encounterDate: encounterDate || dateFormatted,
        encounterInternalId: encounterInternalId || enc.id || '',
        organization: organizationName,
        orgNit: orgNit,
        orgReps: orgReps,
        author: authorName || 'Profesional de la Salud',
        authorDocument: authorDocument,
        authorId: prac.id || '',
        authorRethus: authorRethus,
        status: enc.status || comp.status || 'finalized',
        serviceTypeDisplay: serviceTypeDisplay,
        serviceTypeCode: serviceTypeCode
      };
    },

    /**
     * Parsea recursos clínicos del Bundle (Diagnósticos, Alergias, Medicamentos, Antecedentes Familiares, Procedimientos, Incapacidades)
     */
    getClinicalInfo() {
      const result = {
        diagnoses: [],
        allergies: [],
        medications: [],
        familyHistory: [],
        procedures: [],
        sickLeave: [],
        occupation: null,
        riskFactors: [],
        documents: []
      };

      if (!this.detalleEncuentro || !this.detalleEncuentro.entry) {
        return result;
      }

      this.detalleEncuentro.entry.forEach(e => {
        const res = e.resource;
        if (!res) return;

        // Diagnósticos / Conditions
        if (res.resourceType === 'Condition') {
          let category = res.category?.[0]?.coding?.[0]?.display || res.category?.[0]?.coding?.[0]?.code || 'Encounter Diagnosis';
          let verificationStatus = res.verificationStatus?.coding?.[0]?.display || res.verificationStatus?.coding?.[0]?.code || 'Unconfirmed';
          let clinicalStatus = res.clinicalStatus?.coding?.[0]?.display || res.clinicalStatus?.coding?.[0]?.code || 'Active';

          result.diagnoses.push({
            code: res.code?.coding?.[0]?.code || 'CIE10',
            display: res.code?.coding?.[0]?.display || res.code?.text || 'Diagnóstico',
            category: category,
            verificationStatus: verificationStatus,
            clinicalStatus: clinicalStatus,
            isPrimary: res.extension?.some(ext => ext.url?.includes('primary') && ext.valueBoolean === true)
          });
        }

        // Alergias / AllergyIntolerance
        if (res.resourceType === 'AllergyIntolerance') {
          let typeCode = res.code?.coding?.[0]?.code || '';
          let typeDisplay = res.code?.coding?.[0]?.display || 'Alergia';
          let detail = res.code?.text || res.code?.coding?.[0]?.display || 'Alergia no especificada';
          let verificationStatus = res.verificationStatus?.coding?.[0]?.display || res.verificationStatus?.coding?.[0]?.code || 'Unconfirmed';
          let recordedDate = res.meta?.lastUpdated ? new Date(res.meta.lastUpdated).toLocaleString() : (res.recordedDate ? new Date(res.recordedDate).toLocaleString() : 'N/A');
          let clinicalStatus = res.clinicalStatus?.coding?.[0]?.display || res.clinicalStatus?.coding?.[0]?.code || 'Active';

          result.allergies.push({
            code: typeCode,
            type: typeDisplay,
            display: detail,
            clinicalStatus: clinicalStatus,
            verificationStatus: verificationStatus,
            recordedDate: recordedDate
          });
        }

        // Medicamentos / MedicationRequest o MedicationStatement
        if (res.resourceType === 'MedicationRequest' || res.resourceType === 'MedicationStatement') {
          let medCode = '';
          let medDisplay = '';
          let activeIngredient = '';

          if (res.medicationCodeableConcept) {
            const codings = Array.isArray(res.medicationCodeableConcept.coding)
              ? res.medicationCodeableConcept.coding
              : (res.medicationCodeableConcept.coding ? [res.medicationCodeableConcept.coding] : []);

            if (codings.length > 0) {
              const codes = codings.map(c => c.code).filter(Boolean);
              const displays = codings.map(c => c.display).filter(Boolean);
              medCode = codes.join(' / ');
              activeIngredient = displays.join(' / ');
            }

            medDisplay = res.medicationCodeableConcept.text || activeIngredient || '';
          }

          const di = res.dosageInstruction?.[0] || {};
          const doseAndRate = di.doseAndRate?.[0] || {};

          result.medications.push({
            code: medCode,
            activeIngredient: activeIngredient || medDisplay,
            display: medDisplay,
            status: res.status || 'Active',
            doseValue: doseAndRate.doseQuantity?.value ?? '',
            doseUnit: doseAndRate.doseQuantity?.unit ?? '',
            route: di.route?.coding?.[0]?.display || '',
            rateValue: doseAndRate.rateQuantity?.value ?? '',
            rateUnit: doseAndRate.rateQuantity?.unit ?? '',
            duration: di.timing?.repeat?.duration ?? '',
            durationUnit: di.timing?.repeat?.durationUnit ?? ''
          });
        }

        // Antecedentes Familiares / FamilyMemberHistory
        if (res.resourceType === 'FamilyMemberHistory') {
          let relCode = res.relationship?.coding?.[0]?.code || '';
          let relDisplay = res.relationship?.coding?.[0]?.display || 'Familiar';

          let conditions = [];
          if (res.condition && Array.isArray(res.condition)) {
            res.condition.forEach(c => {
              let cCode = c.code?.coding?.[0]?.code || '';
              let cDisplay = c.code?.coding?.[0]?.display || c.code?.text || '';
              conditions.push({ code: cCode, display: cDisplay });
            });
          }

          result.familyHistory.push({
            relationshipCode: relCode,
            relationshipDisplay: relDisplay,
            conditions: conditions,
            status: res.status || 'Registrado'
          });
        }

        // Procedimientos / ServiceRequest / Procedure
        if (res.resourceType === 'ServiceRequest' || res.resourceType === 'Procedure') {
          result.procedures.push({
            code: res.code?.coding?.[0]?.code || 'CUPS',
            display: res.code?.coding?.[0]?.display || res.code?.text || 'Procedimiento'
          });
        }

        // Incapacidades / SickLeave o Observation (AttendanceAllowanceRDA)
        if (res.resourceType === 'SickLeave') {
          result.sickLeave.push({
            days: res.duration || 1,
            reason: res.description || 'Incapacidad médica',
            startDate: res.period?.start ? new Date(res.period.start).toLocaleDateString() : 'N/A'
          });
        } else if (res.resourceType === 'Observation' && 
                   (res.meta?.profile?.some(p => p.includes('AttendanceAllowanceRDA')) || 
                    res.code?.coding?.some(c => c.code === '160983005'))) {
          
          let days = 'N/A';
          let scope = 'Incapacidad médica';
          
          if (res.component && Array.isArray(res.component)) {
            const timeComp = res.component.find(c => c.id === 'LicenseTime' || c.code?.coding?.some(co => co.code === '410670007'));
            if (timeComp && timeComp.valueQuantity) {
              days = `${timeComp.valueQuantity.value} ${timeComp.valueQuantity.unit || 'días'}`;
            }
            
            const scopeComp = res.component.find(c => c.id === 'LicenseScope' || c.code?.coding?.some(co => co.code === '255590007'));
            if (scopeComp) {
              scope = scopeComp.valueCodeableConcept?.coding?.[0]?.display || scopeComp.valueCodeableConcept?.text || scope;
            }
          }

          let startDate = 'N/A';
          if (res.meta?.lastUpdated) {
            startDate = new Date(res.meta.lastUpdated).toLocaleDateString();
          }

          result.sickLeave.push({
            days: days,
            reason: scope,
            startDate: startDate
          });
        } else if (res.resourceType === 'Observation' && 
                   (res.meta?.profile?.some(p => p.includes('PatientOccupationAtEncounterRDA')) || 
                    res.code?.coding?.some(c => c.code === '184104002'))) {
          
          const coding = res.valueCodeableConcept?.coding?.[0];
          result.occupation = {
            code: coding?.code || 'CIUO',
            display: coding?.display || res.valueCodeableConcept?.text || 'Ocupación registrada'
          };
        }

        // Factores de Riesgo / RiskAssessment (RiskFactorRDA)
        if (res.resourceType === 'RiskAssessment') {
          const coding = res.code?.coding?.[0] || {};
          result.riskFactors.push({
            code: coding.code || 'N/A',
            display: coding.display || 'Factor de Riesgo',
            status: res.status || 'registered',
            description: res.code?.text || coding.display || ''
          });
        }

        // Documentos adjuntos / DocumentReference
        if (res.resourceType === 'DocumentReference') {
          const contentList = res.content || [];
          contentList.forEach(c => {
            if (c.attachment?.url) {
              result.documents.push({
                url: c.attachment.url,
                title: c.attachment.title || res.description || 'Documento Clínico',
                format: c.format?.display || c.attachment.contentType || 'PDF'
              });
            }
          });
        }
      });

      return result;
    },

    getEncounterStatusClass(status) {
      switch (status) {
        case 'finished':
        case 'finalized':
        case 'completed':
          return 'badge-success-soft text-success';
        case 'in-progress':
          return 'badge-warning-soft text-warning';
        default:
          return 'badge-secondary-soft text-gray-600';
      }
    },

    copiarJson() {
      navigator.clipboard.writeText(JSON.stringify(this.detalleEncuentro, null, 2))
        .then(() => {
          Toast.fire({
            icon: 'success',
            title: 'JSON copiado al portapapeles'
          });
        })
        .catch(() => {
          Toast.fire({
            icon: 'error',
            title: 'No se pudo copiar el JSON'
          });
        });
    },

    async abrirDocumentoPDF() {
      if (this.descargandoPDF || !this.compositionSeleccionada) return;

      try {
        this.descargandoPDF = true;

        const response = await ihceService.consultarDocumentoPDF(this.compositionSeleccionada);
        let blobData = response.data;
        let textContent = '';

        if (blobData instanceof Blob) {
          textContent = await blobData.text();
        } else if (typeof blobData === 'string') {
          textContent = blobData;
        } else if (blobData && typeof blobData === 'object') {
          if (blobData.pdf_base64) textContent = blobData.pdf_base64;
          else if (blobData.data) textContent = blobData.data;
          else if (blobData.base64) textContent = blobData.base64;
        }

        // Si la respuesta es JSON (ej. mensaje de error o wrapper)
        if (textContent.trim().startsWith('{')) {
          try {
            const parsed = JSON.parse(textContent);
            if (parsed.pdf_base64 || parsed.data || parsed.base64) {
              textContent = parsed.pdf_base64 || parsed.data || parsed.base64;
            } else if (parsed.message || parsed.error) {
              throw new Error(parsed.message || parsed.error || 'No se pudo obtener el PDF clínico.');
            }
          } catch (e) {
            if (e.message && !e.message.includes('JSON')) throw e;
          }
        }

        let pdfBlob;
        const cleanText = textContent.replace(/^data:application\/pdf;base64,/, '').trim();

        // Si el texto es una cadena Base64 (ej. empieza por "JVBERi")
        if (cleanText.startsWith('JVBERi') || (/^[A-Za-z0-9+/=]+$/.test(cleanText.substring(0, 100)) && cleanText.length > 50)) {
          const rawBinary = window.atob(cleanText);
          const uint8Array = new Uint8Array(rawBinary.length);
          for (let i = 0; i < rawBinary.length; i++) {
            uint8Array[i] = rawBinary.charCodeAt(i);
          }
          pdfBlob = new Blob([uint8Array], { type: 'application/pdf' });
        } else {
          // Si ya son bytes binarios directos
          pdfBlob = blobData instanceof Blob && blobData.type === 'application/pdf'
            ? blobData
            : new Blob([blobData], { type: 'application/pdf' });
        }

        const fileURL = URL.createObjectURL(pdfBlob);
        window.open(fileURL, '_blank');
      } catch (error) {
        console.error('Error al abrir el PDF clínico:', error);
        
        let errorMsg = error.message || 'No se pudo generar o descargar el PDF clínico.';
        if (error.response && error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const parsed = JSON.parse(text);
            if (parsed.message) errorMsg = parsed.message;
            else if (parsed.error) errorMsg = parsed.error;
          } catch (_) { /* Keep default message */ }
        } else if (error.response?.data?.message) {
          errorMsg = error.response.data.message;
        }

        Toast.fire({
          icon: 'error',
          title: 'Error al consultar documento',
          text: errorMsg
        });
      } finally {
        this.descargandoPDF = false;
      }
    },

    formatEncounterDateShort(dateStr) {
      if (!dateStr) return 'N/A';
      return dayjs(dateStr).format("DD/MM/YYYY");
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.nav-tabs .nav-link {
  color: #5a5c69;
  border-radius: 4px;
}
.nav-tabs .nav-link.active {
  background-color: #4e73df !important;
  color: #fff !important;
}
.badge-primary-soft {
  background-color: rgba(78, 115, 223, 0.1);
  color: #4e73df;
}
.badge-success-soft {
  background-color: rgba(28, 200, 138, 0.1);
  color: #1cc88a;
}
.badge-warning-soft {
  background-color: rgba(246, 194, 62, 0.1);
  color: #f6c23e;
}
.badge-secondary-soft {
  background-color: rgba(133, 135, 150, 0.1);
  color: #858796;
}
.border-left-primary {
  border-left: 0.25rem solid #4e73df !important;
}
.border-left-light {
  border-left: 0.25rem solid #e3e6ec !important;
}
.detail-container {
  animation: fadeIn 0.3s ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
